export const STATUS_UNPAID = "UNPAID";
export const STATUS_PAID = "PAID";
export const STATUS_MANDATORY_INFORMATION_MISSING = "MANDATORY_INFO_MISSING";
export const STATUS_INTERNAL_REVIEW = "INTERNAL_REVIEW";
export const STATUS_READY_TO_PICK = "READY_TO_BE_PICKED_UP";
export const STATUS_INFORMATION_REQUIRED = "INFO_NEEDED_CLIENT";
export const STATUS_MI_RAISED_WITH_BOOKS = "MI_RAISED_WITH_BOOKS";
export const STATUS_PREPARATION_IN_PROGRESS = "PREP_IN_PROGRESS";
export const STATUS_IN_FINAL_REVIEW = "IN_FINAL_REVIEW";
export const STATUS_FILED = "FILED";
export const STATUS_DRAFT_SHARED = "DRAFT_SHARED";
export const STATUS_READY_TO_FILE = "READY_TO_FILE";

export const BOOKKEEPING_PURCHASED = "PURCHASED";
export const BOOKKEEPING_UNPAID = "UNPAID";
export const BOOKKEEPING_IN_PROGRESS = "IN_PROGRESS";
export const BOOKKEEPING_SHARED = "SHARED";
export const BOOKKEEPING_COMPLETED = "COMPLETED";
export const BOOKKEEPING_NOT_STARTED = "NOT_STARTED";

export const FILTER_SERVICE_TEAM = "SERVICE_TEAM";
export const FILTER_SERVICE_TEAM_MEMBER = "SERVICE_TEAM_MEMBER";
export const FILTER_INFORMATION_REQUIRED = "INFO_NEEDED_CLIENT";
export const FILTER_BOOKS_PENDING = "BOOKS_PENDING";
export const FILTER_READY_TO_PICK = "READY_TO_BE_PICKED_UP";
export const FILTER_IN_PROGRESS = "PREP_IN_PROGRESS";
export const FILTER_MANDATORY_INFORMATION_MISSING = "MANDATORY_INFO_MISSING";
export const FILTER_INTERNAL_REVIEW = "INTERNAL_REVIEW";
export const FILTER_GLOBAL_STATUS_COMPLETED = "FILED";
export const FILTER_AGENT = "AGENT";
export const FILTER_ETD = "ETD";
export const FILTER_BOOKKEEPING_STATUS = "BOOKKEEPING_STATUS";
export const FILTER_TASK_7004_STATUS = "TASK_7004_STATUS";
export const FILTER_TASK_1120_STATUS = "TASK_1120_STATUS";
export const FILTER_TASK_5471_STATUS = "TASK_5471_STATUS";
export const FILTER_TASK_5472_STATUS = "TASK_5472_STATUS";
export const FILTER_TASK_R_AND_D_STATUS = "TASK_R_AND_D_STATUS";
export const FBAR_STATUS = "FBAR_STATUS";
export const FILTER_STATE_REGISTRATIONS = "STATE_REGISTRATIONS";
export const FILTER_PREV_YEAR_FORM_1120_STATUS = "PREV_YEAR_FORM_1120_STATUS";
export const FILTER_PREV_YEAR_FORM_5471_STATUS = "PREV_YEAR_FORM_5471_STATUS";
export const FILTER_PREV_YEAR_FORM_5472_STATUS = "PREV_YEAR_FORM_5472_STATUS";
export const FILTER_BOOKKEEPERS = "BOOKKEEPERS";
export const FILTER_START_DATE = "START_DATE";
export const FILTER_END_DATE = "END_DATE";
export const FILTER_SELECT_PERIOD = "SELECT_PERIOD";
export const FILTER_PROFITABLE_COMPANY_TAG = "PROFITABLE_COMPANY_TAG";
export const FILTER_ETD_START_DATE = "ETD_START_DATE";
export const FILTER_ETD_END_DATE = "ETD_END_DATE";
export const FILTER_ETD_SELECT_PERIOD = "ETD_SELECT_PERIOD";
export const FILTER_ETD_UNSET = "UNSET";
export const FILTER_ETD_OVERDUE = "OVERDUE";
export const FILTER_ETD_DUE_TODAY = "DUE_TODAY";

export const STATUS_ON_HOLD = "ON_HOLD";

export const STAGE_KEY_IN_QUEUE = "IN_QUEUE";
export const STAGE_KEY_PREP_IN_PROGRESS = "PREP_IN_PROGRESS";
export const STAGE_KEY_BOOKS_PENDING = "BOOKS_PENDING";
export const STAGE_KEY_MI_RAISED_WITH_BOOKS = "MI_RAISED_WITH_BOOKS";
export const STAGE_KEY_REVIEW_IN_PROGRESS = "REVIEW_IN_PROGRESS";
export const STAGE_KEY_REVIEW_IN_FINAL = "REVIEW_IN_FINAL";
export const STAGE_KEY_MISSING_INFORMATION = "MISSING_INFORMATION";
export const STAGE_KEY_DRAFT_SHARED = "DRAFT_SHARED";
export const STAGE_KEY_PREPARER_ASSIGNED = "PREPARER_ASSIGNED";

export const TRACKER_STATUS_NAME_MI_RAISED_WITH_BOOKS = "MI raised with books";
export const TRACKER_STATUS_NAME_IN_FINAL_REVIEW = "In final review";
export const TRACKER_STATUS_NAME_INTERNAL_REVIEW = "Internal Review";

export const FILTER_REVIEWER = "REVIEWER";
export const FILTER_GLOBAL_STATUS = "GLOBAL_STATUS";
export const FILTER_IS_URGENT = "IS_URGENT";
export const FILTER_IS_AMENDMENT = "IS_AMENDMENT";
export const FILTER_PREPARER_ASSIGNED_START_DATE =
  "PREPARER_ASSIGNED_START_DATE";
export const FILTER_PREPARER_ASSIGNED_END_DATE = "PREPARER_ASSIGNED_END_DATE";
export const FILTER_PREPARER_ASSIGNED_SELECT_PERIOD =
  "PREPARER_ASSIGNED_SELECT_PERIOD";
export const FILTER_REVIEWER_ASSIGNED_START_DATE =
  "REVIEWER_ASSIGNED_START_DATE";
export const FILTER_REVIEWER_ASSIGNED_END_DATE = "REVIEWER_ASSIGNED_END_DATE";
export const FILTER_REVIEWER_ASSIGNED_SELECT_PERIOD =
  "REVIEWER_ASSIGNED_SELECT_PERIOD";
export const FILTER_FORM_1120_COMPLETED_START_DATE =
  "FORM_1120_COMPLETED_START_DATE";
export const FILTER_FORM_1120_COMPLETED_END_DATE =
  "FORM_1120_COMPLETED_END_DATE";
export const FILTER_FORM_1120_COMPLETED_SELECT_PERIOD =
  "FORM_1120_COMPLETED_SELECT_PERIOD";

export const UNASSIGNED_OPTION = "UNASSIGNED";

export const NON_PROFIT_501C3 = "Non-profit 501c3";

export const FILTER_ENTITY_TAXED_AS = "ENTITY_TAXED_AS";

export const LLC_FORMATION_TYPE_NAME = "Limited Liability Company";

export const ENTITY_TAXED_AS_OPTIONS = [
  { value: "", label: "All" },
  { value: "CORPORATION", label: "Corporation" },
  { value: "PARTNERSHIP", label: "Partnership" },
  { value: "SINGLE_MEMBER_LLC", label: "Single Member LLC" },
];

export type FilterKeys =
  | "SERVICE_TEAM"
  | "SERVICE_TEAM_MEMBER"
  | "INFO_NEEDED_CLIENT"
  | "BOOKS_PENDING"
  | "READY_TO_BE_PICKED_UP"
  | "PREP_IN_PROGRESS"
  | "MANDATORY_INFO_MISSING"
  | "INTERNAL_REVIEW"
  | "AGENT"
  | "START_DATE"
  | "END_DATE"
  | "SELECT_PERIOD"
  | "ETD"
  | "BOOKKEEPING_STATUS"
  | "TASK_7004_STATUS"
  | "TASK_1120_STATUS"
  | "TASK_5471_STATUS"
  | "TASK_5472_STATUS"
  | "TASK_R_AND_D_STATUS"
  | "FBAR_STATUS"
  | "STATE_REGISTRATIONS"
  | "PREV_YEAR_FORM_1120_STATUS"
  | "PREV_YEAR_FORM_5471_STATUS"
  | "PREV_YEAR_FORM_5472_STATUS"
  | "BOOKKEEPERS"
  | "UNPAID"
  | "FORMATION_TYPE"
  | "PROFITABLE_COMPANY_TAG"
  | "FILED"
  | "DRAFT_SHARED"
  | "READY_TO_FILE"
  | "ETD_START_DATE"
  | "ETD_END_DATE"
  | "ETD_SELECT_PERIOD"
  | "UNSET"
  | "OVERDUE"
  | "DUE_TODAY"
  | "ON_HOLD"
  | "REVIEWER"
  | "PREPARER_ASSIGNED_START_DATE"
  | "PREPARER_ASSIGNED_END_DATE"
  | "PREPARER_ASSIGNED_SELECT_PERIOD"
  | "REVIEWER_ASSIGNED_START_DATE"
  | "REVIEWER_ASSIGNED_END_DATE"
  | "REVIEWER_ASSIGNED_SELECT_PERIOD"
  | "FORM_1120_COMPLETED_START_DATE"
  | "FORM_1120_COMPLETED_END_DATE"
  | "FORM_1120_COMPLETED_SELECT_PERIOD"
  | "GLOBAL_STATUS"
  | "IS_URGENT"
  | "IS_AMENDMENT"
  | "ENTITY_TAXED_AS";

export type FilterValues = {
  SERVICE_TEAM: string | null;
  SERVICE_TEAM_MEMBER: string | null;
  INFO_NEEDED_CLIENT: boolean | null;
  BOOKS_PENDING: boolean | null;
  READY_TO_BE_PICKED_UP: boolean | null;
  PREP_IN_PROGRESS: boolean | null;
  MANDATORY_INFO_MISSING: boolean | null;
  INTERNAL_REVIEW: boolean | null;
  DRAFT_SHARED: boolean | null;
  READY_TO_FILE: boolean | null;
  FILED: boolean | null;
  AGENT: string | null | null;
  START_DATE: string;
  END_DATE: string;
  SELECT_PERIOD: string;
  ETD: string;
  BOOKKEEPING_STATUS: string | null;
  TASK_7004_STATUS: string | null;
  TASK_1120_STATUS: string | null;
  TASK_5471_STATUS: string | null;
  TASK_5472_STATUS: string | null;
  TASK_R_AND_D_STATUS: string | null;
  FBAR_STATUS: string | null;
  STATE_REGISTRATIONS: string | null;
  PREV_YEAR_FORM_1120_STATUS: string | null;
  PREV_YEAR_FORM_5471_STATUS: string | null;
  PREV_YEAR_FORM_5472_STATUS: string | null;
  BOOKKEEPERS: string | null | null;
  UNPAID: boolean | null;
  FORMATION_TYPE: string | null;
  PROFITABLE_COMPANY_TAG: string | null;
  ETD_START_DATE: string;
  ETD_END_DATE: string;
  ETD_SELECT_PERIOD: string;
  UNSET: boolean | null;
  OVERDUE: boolean | null;
  DUE_TODAY: boolean | null;
  ON_HOLD: boolean | null;
  REVIEWER: string | null;
  PREPARER_ASSIGNED_START_DATE: string;
  PREPARER_ASSIGNED_END_DATE: string;
  PREPARER_ASSIGNED_SELECT_PERIOD: string;
  REVIEWER_ASSIGNED_START_DATE: string;
  REVIEWER_ASSIGNED_END_DATE: string;
  REVIEWER_ASSIGNED_SELECT_PERIOD: string;
  FORM_1120_COMPLETED_START_DATE: string;
  FORM_1120_COMPLETED_END_DATE: string;
  FORM_1120_COMPLETED_SELECT_PERIOD: string;
  GLOBAL_STATUS: string | null;
  IS_URGENT: boolean | null;
  IS_AMENDMENT: boolean | null;
  ENTITY_TAXED_AS: string | null;
};

export const globalStatusOptions = [
  { value: STATUS_UNPAID, label: "Unpaid" },
  {
    value: STATUS_MANDATORY_INFORMATION_MISSING,
    label: "Mandatory Information Missing",
  },
  { value: STATUS_READY_TO_PICK, label: "Ready to Pick" },
  { value: STATUS_INTERNAL_REVIEW, label: "Internal Review" },
  { value: STATUS_INFORMATION_REQUIRED, label: "Information Required" },
  { value: STATUS_PREPARATION_IN_PROGRESS, label: "Preparation in Progress" },
  { value: STATUS_FILED, label: "Filed" },
  { value: FILTER_BOOKS_PENDING, label: "Books Pending" },
];

export const bookkeepingStatusOptions = [
  { value: BOOKKEEPING_UNPAID, label: "Unpaid" },
  { value: BOOKKEEPING_IN_PROGRESS, label: "In Progress" },
  { value: BOOKKEEPING_SHARED, label: "Shared by client" },
  { value: BOOKKEEPING_COMPLETED, label: "Completed" },
];
